<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/consulta-ponto', name: 'Inserir ajuste de Registro saída da escola' }
  ]"
/>
<section class="section-filtro">
  <app-filtro-padrao (filtroEmitter)="searchHandler($event)" [template]="2" [style]="1"></app-filtro-padrao>
</section>
<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Inserir ajuste de Registro saída da escola</h2>
    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
  <div class="container boas-vindas">
    <p>
      "Olá, <b>[Nome do Psicólogo]!</b> 👋
    </p>
  </div>
</section>


<section class="section-data-regitro-saida">
  <div class="container">
    <div class="conteudo-data-check-in-out">
      <input
        type="date"
        class="input-date"
        formControlName="dataSaida"
        placeholder="Data da Saída"
        aria-label="Data da Saída"
      />
      <div class="conteudo-check">
        <p>
          Hora Check in:
          <input
            type="time"
            class="input-time"
            formControlName="horarioCheckIn"
            placeholder="Hora Check-Out"
            aria-label="Hora Check-Out"
          />
        </p>
        <p>
          Hora Check-Out:
          <input
            type="time"
            class="input-time"
            formControlName="horarioCheckOut"
            placeholder="Hora Check-Out"
            aria-label="Hora Check-Out"
          />
        </p>
        <p class="horas-trabalhadas">
          Total de horas trabalhadas:<b>02:00</b>
        </p>
      </div>
    </div>
    <button class="btn-registar-saida" disabled>
      Registrar Saída
    </button>
  </div>
</section>


<section class="section-grid-consulta-ponto">

  <div class="container">
    <div class="row_registros">
      <h3>Registro de Entrada e Saída</h3>
      <div class="conteudo-btn-grid">
        <a
        *ngIf="this.userLogado?.codigoPerfil == 1634 || this.userLogado?.codigoPerfil == 1477"
        class="btn_adicionar_registro"
        href="javascript:void(0)"
        (click)="abrirModalInserirRegistro()">
          <i aria-hidden="true" class="fa fa-plus"></i>
        </a>
        <button class="btn_outline" >
          <!-- disabled -->
          Enviar Atividade para Validação
        </button>
      </div>
    </div>
    <div class="row_quantidade_tempo_registro">
      <p>
        <b>Total tempo de atividades registradas: 1:55</b>
      </p>
    </div>

    <div class="conteudo_legenda_grid">
      <h4>Legenda</h4>
      <div class="legenda_grid">
        <div class="legenda_item">
          <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
          <p>Adicionar Registro</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-eye" aria-hidden="true"></i>
          <p>Visualizar</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-edit" aria-hidden="true"></i>
          <p> Edição</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <p>Excluir</p>
        </div>
      </div>
    </div>


  </div>
</section>


